"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var HeartIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M5.23935 6.29447C6.06593 5.42941 7.16178 5.00006 8.25756 5.00006C9.35338 5.00006 10.4488 5.42932 11.2754 6.29441L11.9995 7.05056L12.7236 6.30083C14.377 4.57067 17.1068 4.57078 18.7601 6.30083C20.4133 8.03089 20.4133 10.8056 18.7601 12.5358C16.6543 14.7393 14.5478 16.9453 12.4419 19.1488C12.3257 19.2705 12.1647 19.3394 11.9965 19.3394C11.8275 19.3394 11.6665 19.2705 11.5512 19.1488L5.23935 12.5294C3.58768 10.7977 3.58609 8.02463 5.23935 6.29447Z" }))); };
exports.HeartIcon = HeartIcon;
